module.exports = __webpack_public_path__ + "static/media/galeria4.1b967b25.jpg";